import React, { useState } from "react";
import BaseButtons from "../base-buttons/BaseButtons";
import { colors } from "../../../themes/Colors";

const DropDownWithButton = ({ title, data, setSelectedItem, width, set }) => {
  const [dropDown, setDropDown] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
        marginTop: 40,
      }}
    >
      <BaseButtons
        label={title}
        backgroundColor={colors.greenLight}
        borderRadius={8}
        width={width ? width : 375}
        onClick={set ? null : () => setDropDown(true)}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          height: dropDown ? 300 : 0,
          opacity: dropDown ? 1 : 0,
          width: width ? width : 375,
          backgroundColor: colors.white,
          overflow: "hidden",
          transition: "all 0.3s",
          borderRadius: 8,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          alignItems: "center",
          //WebkitBoxShadow: dropDown
          //  ? "-5px 5px 15px -1px #00000070"
          //  : "0px 0px 0px 0px #00000070",
          zIndex: 200,
        }}
      >
        {data
          ? data.map((option, index) => {
              return (
                <div
                  key={index}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BaseButtons
                    label={option}
                    borderRadius={8}
                    width={"90%"}
                    backgroundColor={colors.greenLight}
                    onClick={() => {
                      setSelectedItem(option);
                      setDropDown(false);
                    }}
                  />
                </div>
              );
            })
          : null}
      </div>
    </div>
  );
};

export default DropDownWithButton;
